import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CurrencyPipe, NgClass} from "@angular/common";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import * as feather from "feather-icons";
import {RepairDto} from "../../../../../auto-generated-server-dtos/claim/repairs/repair-dto";
import {PartDto} from "../../../../../auto-generated-server-dtos/claim/repairs/part-dto";
import { DeleteRepairService } from "../../services/delete-repair.service";

@Component({
  selector: 'app-delete-repair-modal',
  standalone: true,
  imports: [
    CurrencyPipe,
    NgClass
  ],
  templateUrl: './delete-repair-modal.component.html',
  styleUrl: './delete-repair-modal.component.scss'
})
export class DeleteRepairModalComponent implements OnInit {
  @Input() public repair!: RepairDto;
  @Input() public part: PartDto | null = null;
  public busyDeleting: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private deleteRepairService: DeleteRepairService,
  ) {
  }

  ngOnInit() {
    feather.replace();
  }

  public deleteRepairItem(): void {
    this.busyDeleting = true;
    this.deleteRepairService.deleteRepair(this.repair.repairId).subscribe(() => {
      this.activeModal.close();
      this.busyDeleting = false;
    });
  }

  public cancelDelete(): void {
    this.activeModal.dismiss();
  }
}
